import { loadScript } from 'lib/tools/loadScript'

function aliVerify(config = {}) {
  return new Promise((resolve, reject) => {
    let today = new Date()
    const timeStamp = `${today.getFullYear()}${
      today.getMonth() + 1
    }${today.getDay()}`
    let loadUrl = `//g.alicdn.com/AWSC/AWSC/awsc.js`
    loadScript(`${loadUrl}?t=${timeStamp}`).then(() => {
      window.AWSC.use('ic', (state, module) => {
        // 初始化
        window.ic = module.init({
          appkey: config.appkey || 'FFFF000000000182B110',
          scene: config.scene || 'ic_bbs_h5',
          renderTo: config.renderTo || 'aliVerify',
          success: data => {
            resolve(data)
          },
          fail: failCode => {
            window.ic.reset()
            reject(failCode)
          },
          error: errorCode => {
            window.ic.reset()
            reject(errorCode)
          }
        })
      })
    })
  })
}

export default {
  aliVerify
}

export { aliVerify }
